// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/sigmet-area-shapes-and-movement.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/sigmet-area-shapes-and-movement/sigmet-airmet-geometry.js';
import g1 from '../lessons/meteorology/sigmet-area-shapes-and-movement/sigmet-area-shapes-and-movement.js';

mount([g0, g1]);
